import SvgBitcartLogo from "./icons/bitcart-logo.js";
import { BitcartWordmarkIcon } from "./icons/bitcart-wordmark2.js";
//#region src/icons/index.ts
const BitcartLogoIcon = SvgBitcartLogo;
//#endregion
export { BitcartLogoIcon, BitcartWordmarkIcon };

//# sourceMappingURL=icons.js.map